import { PNG } from 'pngjs/browser';

export const isIndexedColorImage = async (file: File): Promise<boolean> => {
  try {
    const png = PNG.sync.read(Buffer.from(await file.arrayBuffer()));

    if ((png.colorType as any) === 3) {
      // need to cast to any because type in lib is invalid
      return true;
    }

    return false;
  } catch (e) {
    return false;
  }
};
